import CookieConsent from "react-cookie-consent";

const CookieSettings = (props) => {
    console.log(props);
    return <CookieConsent
                location="bottom"
                hideOnAccept
                buttonText="Accept"
                cookieName="GDPRCOOKIECONSENT-POSTLOGIN"
                style={{ background: "#242424", fontSize: "12px" }}
                buttonStyle={{ color: "#f8f8f8", fontSize: "14px", border: "1px solid #f8f8f8", background: "#242424" }}
                expires={Number(props.expiry)}
            >
            This website uses cookies to ensure you get the best experience on our website.{' '}
            <a href={`${window.location.origin}/diweb/gdpr/cookie`} target="_blank">More Info</a>
          </CookieConsent>
}

export default CookieSettings;



// WEBPACK FOOTER //
// ./src/core/components/CookieSettings.tsx